<template>
  <v-container
    id="abc-clientes-faturado-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="background-color: #eee; margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <div>
              <v-row>
                <v-col
                  cols="12"
                >
                  <dashboard-filtro-datas
                    :primeiro="enablePrimeiroDia"
                    :ultimo="enableUltimoDia"
                    :empresas="enableEmpresa"
                    :url="link"
                    :vendedores="enableVendedores"
                    :areas="enableAreas"
                    :redes="enableRedes"
                    :supervisores="enableSupervisor"
                    :receitas="enableReceita"
                    :segmentos="enableSegmento"
                    :categorias="enableCategoria"
                    :promotores="enablePromotor"
                  />
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Relatório ABC de Clientes
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('284')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="codigo === '284'"
                            v-html="textoABCClientes"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <v-row
                          v-if="loading"
                          class="v<v-row"
                        >
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <div
                              :style="styleObject"
                              class="text-center"
                            >
                              <v-icon
                                light
                                class="custom-loader"
                                :style="styleObject"
                              >
                                mdi-cached
                              </v-icon>
                              Carregando dados...
                            </div>
                          </v-col>
                        </v-row>
                        <v-row v-else-if="error">
                          <div
                            class="alert alert-danger"
                          >
                            {{ error }}
                          </div>
                        </v-row>
                        <v-row v-else>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <v-data-table
                              id="headersABCCliente"
                              :headers="headersABCCliente"
                              :items="dadosABCCliente"
                              :items-per-page="dadosABCCliente.length"
                              height="500"
                              fixed-header
                              disable-sort
                              hide-default-footer
                              class="elevation-1"
                              style="color: black"
                            >
                              <template v-slot:[`item.variacao`]="{ item }">
                                <td
                                  class="text-right title"
                                  :style="getColorVariacao(item.variacao)"
                                >
                                  <span>
                                    {{ item.variacao }}
                                  </span>
                                </td>
                              </template>
                              <template v-slot:[`item.porcentagem_abc`]="{ item }">
                                <td
                                  class="text-right title"
                                  :style="getColorABC(item.porcentagem_abc)"
                                >
                                  <span id="dadoMovimentacao">
                                    {{ item.porcentagem_abc }}
                                  </span>
                                </td>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Cliente from '../../../../../services/clientes'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardExtratoCliente',
    emits: ['atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      enableConsulta: false,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedores: true,
      enableAreas: true,
      enableRedes: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      enableCategoria: true,
      enablePromotor: true,
      link: localStorage.linkClientes,
      dadosABCCliente: [],
      headersABCCliente: [
        { text: 'Cliente', value: 'cliente', width: '250px', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Fat. do ano anterior', value: 'faturamento_anterior', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Variação de fat. Anual', value: 'variacao', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Participação fat. Anual', value: 'participacao', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Rank atual', value: 'rank', width: '100px', align: 'right', class: 'black--text title' },
        { text: '% ABC', value: 'porcentagem_abc', width: '100px', align: 'right', class: 'black--text title' },
      ],
      loading: false,
      error: null,
      codigo: 0,
      orientacao: [],
      textoABCClientes: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'ABC de Participantes')

        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoPartipantes'))
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.updateDate()
      },

      updateDate () {
        this.dadosABCCliente = []

        this.showDadosABCCliente()
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '284') {
            this.textoABCClientes = this.orientacao[i].descricao
          }
        }
      },

      async showDadosABCCliente () {
        this.loading = true

        await Cliente.showDadosABCCliente(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.dadosABCCliente = resposta.data.dadosABCCliente.map((item) => {
              var listaAbc = ({
                cliente: item.cliente,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento_anterior: item.faturamento_anterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao: item.variacao + '%',
                participacao: item.participacao.toFixed(2).replace('.', ',') + '%',
                rank: item.rank,
                porcentagem_abc: item.porcentagem_abc.toFixed(2).replace('.', ',') + '%',
              })

              return listaAbc
            })
          } else if (resposta.data.msg === 'Não há faturamento para o(s) cliente(s) no período selecionado') {
            this.dadosABCCliente = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getColorVariacao (value) {
        if (value.replace('%', '').replace(',', '.') > parseFloat(0)) {
          return 'color: #4CAF50'
        } else {
          return 'color: #f27686'
        }
      },

      getColorABC (value) {
        if (value.replace('%', '').replace(',', '.') < parseFloat(70)) {
          return 'color: #4CAF50'
        } else if (value.replace('%', '').replace(',', '.') >= parseFloat(70) && value.replace('%', '').replace(',', '.') <= parseFloat(90)) {
          return 'color: #FFEB3B'
        } else {
          return 'color: #f27686'
        }
      },
    },
  }
</script>
<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemABCClientes
    padding-right: 113rem !important
    margin: -2rem 0 0 -1rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #iconInformationFaturamentoClientes {
      margin: 0 0 0 -1rem;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }
</style>
